<script setup>
defineProps({
  background: {
    type: String,
    default: 'bg-dss-surface-50',
  },
})
</script>

<template>
  <section
    class="p-6 border border-dss-surface-200 rounded-2xl"
    :class="background"
  >
    <slot />
  </section>
</template>

<style scoped></style>
